exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card[data-v-036cba53]{margin-top:0;margin-bottom:0}.v-list-item[data-v-036cba53]{padding:0 12px}.link-container[data-v-036cba53]:hover{cursor:pointer}.link-icon[data-v-036cba53]{background-color:#92949c}.link-container:hover .link-icon[data-v-036cba53],.link-icon.active[data-v-036cba53]{background-color:#ab3b7a}", ""]);

// exports
